import { SELECT_SAMPLE } from '../actions/actionTypes'

const selectedSample = ( state = {}, action) =>{
	switch(action.type){
		case SELECT_SAMPLE:{
			return action.id;
		}
		default:
			return state;
	}
}

export default selectedSample;


// WEBPACK FOOTER //
// ./src/reducers/selectedSample.js